import { Injectable, inject } from '@angular/core'
import { UiConfirmOptions, UiDialogService } from './ui-dialog.service'

@Injectable({
	providedIn: 'root'
})
export class ConfirmService {
	private uiDialogService = inject(UiDialogService)

	async openConfirm(confirmMessage: string, options: UiConfirmOptions = {}) {
		return await this.uiDialogService.openConfirm(confirmMessage, options)
	}
}
